import Phaser from 'phaser'
import Config from '../launch/config'
import {_setMinimapOpen} from '../app/app'

export default class Minimap {
    constructor() {
        this.active = false
    }

    hide() {
        Config.scene.cameras.remove(this.camera)
        this.active = false
    }

    show() {
        const camera = Config.scene.cameras.main
        // const isWindows = window.navigator.userAgent.includes('Windows')
        // const pixelRatio = isWindows ? 2 : window.devicePixelRatio
        const miniWidth = 300
        const miniRect = new Phaser.Geom.Rectangle(
            0, // camera.width - miniWidth, // x
            60, // y
            miniWidth, // w
            miniWidth // h
        )

        const miniBoardSizeMap = {
            size1: {
                coords: 3.8, // Offset for click pan to x/y
                zoom: 0.27, // Zoom of mini
                origin: 0.37, // Top/Left alignment of board within mini
            },
            size2: {
                coords: 4.3,
                zoom: 0.23,
                origin: 0.3,
            },
            size3: {
                coords: 4.8,
                zoom: 0.2,
                origin: 0.25,
            },
        }

        this.active = true
        this.camera = Config.scene.cameras
            .add(miniRect.x, miniRect.y, miniRect.width, miniRect.height)
            .setZoom(miniBoardSizeMap[Config.boardSize].zoom)
            .setName('mini')
            .setOrigin(miniBoardSizeMap[Config.boardSize].origin)
        this.camera.setBackgroundColor(0x1c0f3a)
        this.camera.scrollX = miniRect.width
        this.camera.scrollY = miniRect.height
        // this.camera.alpha = 0.8
        // this.camera.setTint(0xffff00)
        // this.camera.transparent = true

        Config.scene.input.on('pointerdown', (pointer) => {
            if (!this.active) {
                return
            }

            this.hide()
            _setMinimapOpen(false)

            const pointerRect = new Phaser.Geom.Rectangle(
                pointer.x,
                pointer.y,
                1,
                1
            )

            const intersection = Phaser.Geom.Intersects.GetRectangleIntersection(
                miniRect,
                pointerRect
            )

            if (!intersection.width) {
                return
            }

            intersection.x -= miniRect.x
            intersection.y -= miniRect.y
            const coords = {
                x: intersection.x * miniBoardSizeMap[Config.boardSize].coords,
                y: intersection.y * miniBoardSizeMap[Config.boardSize].coords,
            }

            camera.pan(coords.x, coords.y, 300, 'Linear', true)
            camera.zoomTo(Config.zoomDefault, 10)
        })
    }
}
